<template>
  <div>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import store from "@/store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueSession from "vue-session";

const cryptoJSON = require("crypto-json");
const algorithm = "camellia-128-cbc";
const encoding = "hex";

Vue.use(VueSession);

@Component({
  component: {
    store,
    axios,
    VueAxios
  },
  data() {
    return {
      show: false,
      form: {
        username: "",
        password: ""
      },
      ApiKey: "",
      CloseFalse: false
    };
  },
  mounted() {
    if (localStorage.name) {
      this.ApiKey = this.$store.get("systems@ApiKey");
    }
  },
  created() {
    this.AutoLogin(this.$route.params.com);
  },
  methods: {
    AutoLogin(com) {
      if (com != "" && com != null) {
        this.LogformSubmit(com);
      }
    },
    LogformSubmit(com) {
      let pwd = this.form.password;

      let currentObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "UserAuthenCM", {
          CompanyId: this.$store.get("systems@CompanyId"),
          com: com
        })
        .then(function(response) {
          currentObj.output = response.data;
          if (currentObj.output.status === true) {
            store.set("systems@ApiKey", currentObj.output.result.ApiKey);
            store.set("systems@LoginStatus", true);
            store.set("systems@LoginData", currentObj.output.result);
            store.set("systems@ErrorMessageApi", "");
            store.set("systems@ErrorMessageApiStatus", false);

            currentObj.$session.start();
            currentObj.$session.set("LoginStatus", true);

            const password = "hisSMPK10685";
            const input = currentObj.output.result;

            const algorithm = "aes256";
            const encoding = "hex";
            const keys = [
              "hospCode",
              "hospName",
              "userName",
              "ApiKey",
              "DoctorCode",
              "UserId",
              "groupname",
              "vn_str",
              "an_str",
              "hn_str",
              "hos_accessright",
              "entryposition",
              "accessright",
              "user_id",
              "modul",
              "DID"
            ];

            let tnow = new Date()

            let Days = ''
            let Months = ''
            let Hours = ''
            let Minutes = ''
            let Seconds = ''

            if (tnow.getDate().toString().length == 1) {
              Days = '0' + tnow.getDate().toString()
            } else {
              Days = tnow.getDate().toString()
            }

            if ((tnow.getMonth() + 1).toString().length == 1) {
              Months = '0' + (tnow.getMonth() + 1).toString()
            } else {
              Months = (tnow.getMonth() + 1).toString()
            }

            let DateNow = tnow.getFullYear() + '-' + Months + '-' + Days;

            if (tnow.getHours().toString().length == 1) {
              Hours = '0' + tnow.getHours().toString()
            } else {
              Hours = tnow.getHours().toString()
            }

            if (tnow.getMinutes().toString().length == 1) {
              Minutes = '0' + tnow.getMinutes().toString()
            } else {
              Minutes = tnow.getMinutes().toString()
            }

            if (tnow.getSeconds().toString().length == 1) {
              Seconds = '0' + tnow.getSeconds().toString()
            } else {
              Seconds = tnow.getSeconds().toString()
            }

            input.DID = DateNow + ' ' + Hours + ':' + Minutes + ':' + Seconds; 

            const output = cryptoJSON.encrypt(input, password, {
              encoding,
              keys,
              algorithm
            });

            currentObj.$session.set("LoginData", output);

            currentObj.show = false;

            // console.log(currentObj.output.result.vn_str);

            if (
              currentObj.output.result.vn_str != "" &&
              currentObj.output.result.vn_str != null
            ) {
              store.set("systems@SearchPT", true);
              store.set("systems@SearchPTid", currentObj.output.result.hn_str);

              currentObj.$router.push({
                path:
                  "/PatientEMR/" +
                  currentObj.output.result.hn_str +
                  "/" +
                  currentObj.output.result.vn_str
              });
            } else {
              currentObj.$router.push({
                path: "/PatientEMR"
              });
            }
          } else {
            store.set("systems@LoginStatus", false);
            store.set("systems@LoginData", []);
            store.set(
              "systems@ErrorMessageApi",
              currentObj.output.ErrorMessage
            );
            store.set("systems@ErrorMessageApiStatus", true);
          }
        })
        .catch(function(error) {
          currentObj.output = error;

          store.set("systems@LoginStatus", false);
          store.set("systems@LoginData", []);
          store.set("systems@ErrorMessageApi", currentObj.output);
          store.set("systems@ErrorMessageApiStatus", true);
        });
    }
  }
})
export default class LoginHOSxP extends Vue {}
</script>


<style lang="scss">
</style>
